import { useState } from 'react';
import { type Token } from '@/shared/assets/tokens';
import { removeCommas } from '@/shared/utils/strings';
import TokenAmount from '@/shared/utils/TokenAmount';

export default function useValidatedTokenAmount(
  amount: string,
  token: Token | undefined,
): TokenAmount | undefined {
  const [tokenAmount, setTokenAmount] = useState<TokenAmount | undefined>(() =>
    amount === ''
      ? undefined
      : TokenAmount.fromWholeUnits(removeCommas(amount), token?.decimals ?? 18),
  );

  if (amount === '') {
    if (tokenAmount !== undefined) setTokenAmount(undefined);
  } else {
    const newAmount = TokenAmount.fromWholeUnits(removeCommas(amount), token?.decimals ?? 18);
    if (!newAmount.isNaN() && !tokenAmount?.eq(newAmount)) {
      setTokenAmount(newAmount);
    }
  }

  return tokenAmount;
}
